export function getSeenBrandingIntroFromLocalstorage() {
  return window.localStorage.getItem("seenBrandingIntro") //true or false
}

export function setSeenBrandingIntroInLocalstorage() {
  window.localStorage.setItem("seenBrandingIntro", true)
}



// WEBPACK FOOTER //
// ./src/branding-intro/branding-intro-localstorage-operations.js